// Aset & Maintenance API client — pembungkus /api/aset/* (26 rute, Tahap 2–4a).
//
// ATURAN FILE INI (sama dengan purchasingApi.js):
//   * Client TIDAK menjaga apa pun. Wewenang peran/region (PERAN_KELOLA,
//     PERAN_CATAT, R9–R12, PIC wajib) ditegakkan backend/services/aset_service.py.
//   * Nol konstanta bisnis di sini: label, rona, kategori, bentuk jadwal,
//     status — SEMUA dari GET /api/aset/meta (L4–L8, S1). Lihat hooks/useAsetMeta.
//   * Pembungkus dibuat bersama layar yang memakainya. 4b-1 memakai daftar,
//     detail, aset, jadwal, nota aset, dan tiga pembaca riwayat (log/laporan/km).
//     4b-2 menambah catat servis + nota log + km; laporan bulanan = 4b-3.
import { api } from "./api";

// ---------- meta ----------
export const getAsetMeta = () => api.get("/aset/meta");

// ---------- aset ----------
// GET ?region_id= (OWNER saja; KC/ADMIN dijepit region profil), ?status=, ?kategori=
export const listAset = (params) => api.get("/aset", { params });
// Kartu B2: aset AKTIF tanpa satu pun jadwal aktif (?region_id= untuk OWNER)
export const listAsetTanpaJadwal = (params) => api.get("/aset/tanpa-jadwal", { params });
// { aset, jadwal (semua, termasuk nonaktif), jatuh_tempo (view, aktif saja), laporan_status (view) }
export const getAset = (id) => api.get(`/aset/${id}`);
// OWNER wajib region_id; KC = region profil. pic_employee_id WAJIB. Status awal selalu AKTIF.
export const createAset = (body) => api.post("/aset", body);
// Hanya KOLOM_ASET_UBAH; status/kategori/region/nota ditolak 400.
export const updateAset = (id, body) => api.patch(`/aset/${id}`, body);
// OWNER saja, hanya tanpa riwayat (409 ASET_PUNYA_RIWAYAT).
export const deleteAset = (id) => api.delete(`/aset/${id}`);
// Satu-satunya jalan ubah status (RPC aset_ubah_status). Alasan wajib ke status keluar (R2).
export const ubahStatusAset = (id, body) => api.post(`/aset/${id}/status`, body);
export const uploadNotaAset = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/aset/${id}/nota`, fd, { headers: { "Content-Type": "multipart/form-data" } });
};
export const getNotaAsetUrl = (id) => api.get(`/aset/${id}/nota`);

// ---------- jadwal ----------
export const listJadwalAset = (asetId) => api.get(`/aset/${asetId}/jadwal`);
// Lintas aset dari view v_aset_jadwal_jatuh_tempo (?region_id=, ?status_pengingat=, ?aset_id=) — layar 4b-2
export const listJadwalJatuhTempo = (params) => api.get("/aset/jadwal", { params });
export const createJadwal = (asetId, body) => api.post(`/aset/${asetId}/jadwal`, body);
// is_active DITOLAK di PATCH (R7) — pakai nonaktif/aktif. Periode/jangkar saat TERLAMBAT/KM_BASI hanya OWNER (R10).
export const updateJadwal = (id, body) => api.patch(`/aset/jadwal/${id}`, body);
export const nonaktifkanJadwal = (id, body) => api.post(`/aset/jadwal/${id}/nonaktif`, body);
export const aktifkanJadwal = (id, body) => api.post(`/aset/jadwal/${id}/aktif`, body);
// OWNER saja, hanya tanpa log (409 JADWAL_PUNYA_LOG).
export const deleteJadwal = (id) => api.delete(`/aset/jadwal/${id}`);

// ---------- catat (4b-2) ----------
// PERAN_CATAT region aset (OWNER, KC, ADMIN_GUDANG, ADMIN_PRODUKSI) atau PIC ber-akun.
// RPC aset_catat_log_maintenance: log + pembacaan LOG_SERVIS (kendaraan) + nonaktif
// jadwal TANGGAL saat PREVENTIVE SELESAI; balikan memuat log_id. R9: log PERMANEN.
export const catatLogAset = (asetId, body) => api.post(`/aset/${asetId}/log`, body);
// Sekali tulis (409 NOTA_SUDAH_ADA); dipanggil SESUDAH log tersimpan.
export const uploadNotaLog = (logId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/aset/log/${logId}/nota`, fd, { headers: { "Content-Type": "multipart/form-data" } });
};
// sumber MANUAL (PERAN_CATAT + PIC ber-akun) | KOREKSI (KC/OWNER, wajib km_odometer_lama + catatan, R11).
// tanggal_baca diisi RPC menurut zona region — nol dikirim dari layar.
export const catatKmAset = (asetId, body) => api.post(`/aset/${asetId}/km`, body);
// Laporan bulanan (4b-3): PERAN_CATAT + PIC ber-akun; pelapor = PIC aset (backend);
// periode YYYY-MM-01 dari baris view; RPC: R3 ASET_SUDAH_KELUAR, KM_WAJIB_KENDARAAN,
// HILANG_TIDAK_DITEMUKAN → status HILANG + jadwal nonaktif; balikan status_aset_baru, jadwal_dinonaktifkan.
export const catatLaporanAset = (asetId, body) => api.post(`/aset/${asetId}/laporan`, body);

// ---------- riwayat (baca) ----------
export const listLogAset = (asetId) => api.get(`/aset/${asetId}/log`);
export const getNotaLogUrl = (logId) => api.get(`/aset/log/${logId}/nota`);
// { items, count, total, limit, offset } — periode DESC, limit bawaan 24 / plafon 120
export const listLaporanAset = (asetId, params) => api.get(`/aset/${asetId}/laporan`, { params });
export const listKmAset = (asetId) => api.get(`/aset/${asetId}/km`);
// Status kewajiban laporan bulan berjalan/lalu dari view (?region_id=, ?status_pengingat=, ?aset_id=) — layar 4b-3
export const listStatusLaporan = (params) => api.get("/aset/laporan/status", { params });

// apiErrorMessage TIDAK diduplikasi — sumber tunggalnya inventoryApi.js.
// Pesan backend (400/403/409) ditampilkan verbatim.
export { apiErrorMessage } from "./inventoryApi";
